import styled from 'styled-components';
import HintBlock from '../../../../HintBlock';

export const FormContainer = styled.form`
  width: 253px;
  padding: 12px;
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 12px;
  margin-top: 16px;
`;

export const StyledHintBlock = styled(HintBlock)`
  margin-bottom: 8px;
  column-gap: 4px;
`;
